import React, { useState } from "react";

import api from "../../services/api";

/**
 * The body of a deleted message: hidden until staff click for it (2026-10-26).
 *
 * `url` is the reveal endpoint for this one message. The history payload never
 * carries deleted text; each click fetches it, and the backend writes an audit
 * row before answering -- so the button says that the look is recorded.
 */
const DeletedBody = ({ url }) => {
  const [st, setSt] = useState({ body: null, loading: false, error: "" });

  const reveal = async () => {
    setSt({ body: null, loading: true, error: "" });
    try {
      const res = await api.post(url);
      setSt({ body: res.data.body ?? "", loading: false, error: "" });
    } catch {
      setSt({ body: null, loading: false, error: "Matnni olib boʻlmadi" });
    }
  };

  if (st.body !== null) {
    return <span className="ms-chat-text is-revealed">{st.body || "—"}</span>;
  }

  return (
    <span className="ms-chat-gone">
      Matn muallif tomonidan oʻchirilgan{" "}
      <button
        type="button"
        className="ms-chat-reveal"
        onClick={reveal}
        disabled={st.loading}
        title="Koʻrilgani audit jurnaliga yoziladi"
      >
        {st.loading ? "…" : "Matnni koʻrish"}
      </button>
      {st.error && <span className="ms-chat-flag"> {st.error}</span>}
    </span>
  );
};

export default DeletedBody;
